
import { DataType } from "@dndModels/Types";
import { PlayerObject } from "@models";

/**
 * This is an object that allows for DMs and players to send items or conditions to players in a campaign.
 */
export class CharacterReceivable extends PlayerObject {
  data_type: DataType = "character_receivable";
  char_id = ""; // id of char who is receiving it
  from_id = ""; // DM or id of char who sent it
  sent_dt = 0;
  received_dt = 0;
  message = "";
  items: CharacterReceivableItem[] = [];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.char_id = obj.char_id ? obj.char_id : "";
      this.from_id = obj.from_id ? obj.from_id : "";
      this.sent_dt = obj.sent_dt ? obj.sent_dt : 0;
      this.received_dt = obj.received_dt ? obj.received_dt : 0;
      this.message = obj.message ? obj.message : "";
      this.items = obj.items ? obj.items.map((item: any) => new CharacterReceivableItem(item)) : [];
    }
  }

  toDBObj(): any {
    return {
      ...super.toDBObj(),
      char_id: this.char_id,
      from_id: this.from_id,  
      sent_dt: this.sent_dt,
      received_dt: this.received_dt,
      message: this.message,
      items: this.items.map((item: CharacterReceivableItem) => item.toDBObj()),
    };
  }

  clone(): CharacterReceivable {
    const clone = new CharacterReceivable();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CharacterReceivable): void {
    super.copy(copyMe);
    this.char_id = copyMe.char_id;
    this.from_id = copyMe.from_id;
    this.sent_dt = copyMe.sent_dt;
    this.received_dt = copyMe.received_dt;
    this.message = copyMe.message;
    this.items = copyMe.items.map((item: CharacterReceivableItem) => item.clone());
  }
}

export class CharacterReceivableItem {
  type: "Condition" | "Item" | "Gift" | "Item Enhancement" = "Item";
  obj_id = ""; // for item it's item.pseudo_item_id, for enhancement it will probably have to be a variant of pseudo_item_id, for condition and gift it's the _id
  count = 0; // for condition and gift it's the level

  constructor(obj?: any) {
    if (obj) {
      this.type = obj.type ? obj.type : "Item";
      this.obj_id = obj.obj_id ? obj.obj_id : "";
      this.count = obj.count ? obj.count : 0;
    }
  }

  toDBObj(): any {
    return {
      type: this.type,
      obj_id: this.obj_id,
      count: this.count,
    };
  }

  clone(): CharacterReceivableItem {
    const clone = new CharacterReceivableItem();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CharacterReceivableItem): void {
    this.type = copyMe.type;
    this.obj_id = copyMe.obj_id;
    this.count = copyMe.count;
  }
}